// extracted by mini-css-extract-plugin
module.exports = {"spotMap":"SpotMap_spotMap__JYJfn","spotMapOverlayMarker":"SpotMap_spotMapOverlayMarker__CtoJ5"};